import { useNavigate, useLocation } from "react-router-dom";
import { scrollToId } from "./scroll";
import { trackEvent } from "./tracking";

// Section navigation that works from every route: scrolls on the home page,
// or navigates home first (hash lands on the right section) then scrolls.
export function useGoToSection() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  return (id, source) => (e) => {
    e.preventDefault();
    trackEvent("cta_click", { location: source, target: id });
    if (pathname !== "/") {
      navigate(`/#${id}`);
    } else {
      scrollToId(id);
    }
  };
}

export default useGoToSection;
